import React from 'react';
import WmwSection8a from '../../../../course/churchschool/wmw/WmwSection8a';
import JepsplSection from '../../../../course/churchschool/JepsplSection';
import WarningSection from '../../../../course/churchschool/WarningSection';
import WmwSection14 from '../../../../course/churchschool/wmw/WmwSection14';
import GodDealWeekSectionOct, {
  IS_DISPLAY_GODDEAL_SECTION,
} from '../../../../course/churchschool/event/GodDealWeekSectionOct';

const BoostupWmwBookMain = () => {
  return (
    <>
      {IS_DISPLAY_GODDEAL_SECTION && <GodDealWeekSectionOct />}
      <WmwSection8a />
      <WarningSection />
      <JepsplSection />
      <WmwSection14 />
    </>
  );
};

export default BoostupWmwBookMain;
